/**
 * Donation Messaging Service
 * Simplified single-message approach for all announcements
 */

/**
 * Check if announcement is Jumua/Friday prayer
 * @param {Object} announcement - Announcement object
 * @returns {boolean} True if Jumua announcement
 */
export function isJumuaAnnouncement(announcement) {
  if (!announcement) return false;

  const title = announcement.title?.toLowerCase() || '';

  // Check for Jumua variations in title
  return (
    title.includes('jumua') ||
    title.includes('jumu\'ah') ||
    title.includes('jumuah') ||
    title.includes('friday prayer') ||
    announcement.category?.toLowerCase() === 'jumua'
  );
}

/**
 * Generate donation message based on announcement type
 * @param {Object} announcement - Announcement object
 * @param {string} paymentLink - Stripe payment link
 * @returns {string} Formatted donation message
 */
export function generateDonationMessage(announcement, paymentLink) {
  const isJumua = isJumuaAnnouncement(announcement);

  return isJumua
    ? `Support Dar-e-Zainab (as) this Friday: ${paymentLink}`
    : `Support Dar-e-Zainab (as): ${paymentLink}`;
}

/**
 * Track donation message analytics
 * @param {Object} data - Analytics data
 * @returns {Promise<void>}
 */
export async function trackDonationMessage(data) {
  try {
    // Import supabase dynamically to avoid circular dependencies
    const { supabase } = await import('../lib/supabaseClient');

    const { error } = await supabase
      .from('donation_message_analytics')
      .insert({
        announcement_id: data.announcement_id,
        center_id: data.center_id,
        approach: 'single-message-simplified',
        variant: data.variant, // 'jumua' or 'standard'
        sent_at: data.sent_at,
        recipients_count: data.recipients_count || 0
      });

    if (error) {
      console.error('[donationMessagingService] Error tracking analytics:', error);
    } else {
      console.log('[donationMessagingService] Analytics tracked:', data);
    }
  } catch (error) {
    console.error('[donationMessagingService] Failed to track analytics:', error);
  }
}
